import PropTypes from 'prop-types';
import React from 'react';
import FeedbackFace from './FeedbackFace';

const FeedbackRating = (props) => {
    const { setChosenFace, setDisabled } = props;

    const ratings = [
        { value: 0, text: 'Forferdelig' },
        { value: 1, text: 'Ikke så bra' },
        { value: 2, text: 'Ganske bra' },
        { value: 3, text: 'Kjempebra' },
    ];

    const faces = ratings.map((rating) => {
        return (
            <FeedbackFace
                nr={rating.value}
                text={rating.text}
                key={rating.value}
                onClick={() => setChosenFace(rating.value)}
                disabled={setDisabled(rating.value)}
            />
        );
    });

    return (
        <>
            <h3 className="u-text-center u-t2">
                Hvor fornøyd er du med anbefalingene du har fått her?
            </h3>
            <div className="grid u-mt32">{faces}</div>
        </>
    );
};
FeedbackRating.propTypes = {
    setChosenFace: PropTypes.func.isRequired,
    setDisabled: PropTypes.func.isRequired,
};
export default FeedbackRating;
